export class PanasonicProjectorRs232 {
    constructor(socket, log) {
        this.socket = socket;
        this.firmwareVersion = '1.00.01';
        this.power = false;
        this.serialNumber = 'SW12345678';
        this.videoMute = false;
        this.videoSelection = 'HD1';
        this.volume = 32;
        this.volumeMute = false;
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /\x02ADZZ;QVX:SVRS0/i,
                callback: (match) => {
                    this.socket.send(`\x02SVRS0=${this.firmwareVersion}`);
                },
            },
            {
                name: 'serialNumber',
                regExp: /\x02ADZZ;QSN/i,
                callback: (match) => {
                    this.socket.send(`\x02${this.serialNumber}`);
                },
            },
            {
                name: 'powerQuery',
                regExp: /\x02ADZZ;QPW/i,
                callback: (match) => {
                    this.socket.send(`\x02${this.power ? '001' : '000'}`);
                },
            },
            {
                name: 'powerSet',
                regExp: /\x02ADZZ;P(ON|OF)/i,
                callback: (match) => {
                    this.power = match[1] === 'ON';
                    this.socket.send(`\x02P${match[1]}`);
                },
            },
            {
                name: 'videoMuteQuery',
                regExp: /\x02ADZZ;QSH/i,
                callback: (match) => {
                    this.socket.send(`\x02${this.videoMute ? '001' : '000'}`);
                },
            },
            {
                name: 'videoMuteSet',
                regExp: /\x02ADZZ;OSH:(\d+)/i,
                callback: (match) => {
                    this.videoMute = match[1] === '1';
                    this.socket.send(`\x02OSH:${this.videoMute ? '001' : '000'}`);
                },
            },
            {
                name: 'videoQuery',
                regExp: /\x02ADZZ;QIN/i,
                callback: (match) => {
                    this.socket.send(`\x02${this.videoSelection}`);
                },
            },
            {
                name: 'videoSet',
                regExp: /\x02ADZZ;IIS:(.+)/i,
                callback: (match) => {
                    this.videoSelection = match[1];
                    this.socket.send(`\x02IIS:${match[1]}`);
                },
            },
            {
                name: 'volumeQuery',
                regExp: /\x02ADZZ;QAV/i,
                callback: (match) => {
                    this.socket.send(`\x02${this.volume.toString().padStart(3, '0')}`);
                },
            },
            {
                name: 'volumeSet',
                regExp: /\x02ADZZ;AVL:(\d+)/i,
                callback: (match) => {
                    this.volume = parseInt(match[1], 10);
                    this.socket.send(`\x02AVL:${match[1]}`);
                },
            },
            {
                name: 'volumeMuteQuery',
                regExp: /\x02ADZZ;QMT/i,
                callback: (match) => {
                    this.socket.send(`\x02${this.volumeMute ? '001' : '000'}`);
                },
            },
            {
                name: 'volumeMuteSet',
                regExp: /\x02ADZZ;AMT:(\d+)/i,
                callback: (match) => {
                    this.volumeMute = match[1] === '1';
                    this.socket.send(`\x02AMT:${match[1]}`);
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`ERR1`);
                },
            },
        ];
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            const code = videoInput.code;
            if (this.videoSelection === code)
                return;
            if (lowestCode === undefined || code < lowestCode) {
                lowestCode = code;
            }
        }
        this.videoSelection = lowestCode !== null && lowestCode !== void 0 ? lowestCode : 'HD1';
    }
}
PanasonicProjectorRs232.emulatorType = 'socketEmulator';
PanasonicProjectorRs232.key = '-LWVuYtXFO3gV2S45arc';
